import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-appreport',
  templateUrl: './appreport.component.html',
  styleUrls: ['./appreport.component.css']
})
export class AppreportComponent implements OnInit {

  commonUrl : string 
  

  constructor(private userService: UserService)  { 
    this.commonUrl = userService.rootUrl;
  }

  ngOnInit() {
  }

  ReceiptVoucher(){
    window.open(this.commonUrl+'/Reports/Report.aspx?id=1');
  }

  PaymentVoucher(){
    window.open(this.commonUrl+'/Reports/DatasetReports.aspx?id=2');
  }

  AccStatement(){
    window.open(this.commonUrl+'/Reports/AccountStat/AccountStatement.aspx');
  }

  ACCBALANCE(){
    window.open(this.commonUrl+'/Reports/ScheduleReport/schedulereport.aspx');
  }

  PigmyMonthy(){
    window.open(this.commonUrl+'/Reports/PigmyMonthly/PigmyMonthly.aspx');
  }


  ProductDetails(){
    window.open(this.commonUrl+'/Reports/SeeMyproduct/SeeMyProduct.aspx');
  }

  PigmyMonthy0(){
    window.open(this.commonUrl+'/Reports/PigmyMonthly2/PigmyMonthly1.aspx');
  }

  

  TranDetails(){
    window.open(this.commonUrl+'/Reports/Report.aspx?id=8');
  }

  Monthcol(){
    window.open(this.commonUrl+'/Reports/PigmyManulaCo/PigmyManualcol.aspx');
  }

  tranbasic(){
    window.open(this.commonUrl+'/Reports/Report.aspx?id=10');
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/appreport/appreport.component.ts